/*! Lumina Gems HK — Google Ads WhatsApp wa-paraiba click conversion
 * send_to: AW-18083319417/VJfCCN3Sn7AdEPmc5q5D
 * Captures clicks on links whose href contains wa-paraiba (e.g. /r/wa-paraiba).
 */
(function () {
  function isWaParaibaHref(href) {
    if (!href) return false;
    try {
      var u = new URL(href, window.location.origin);
      return u.pathname.indexOf('wa-paraiba') !== -1 || href.indexOf('wa-paraiba') !== -1;
    } catch (e) {
      return String(href).indexOf('wa-paraiba') !== -1;
    }
  }

  function fireConversion(thenGo) {
    var done = false;
    var go = function () {
      if (done) return;
      done = true;
      thenGo();
    };
    if (typeof gtag === 'function') {
      try {
        gtag('event', 'conversion', {
          send_to: 'AW-18083319417/VJfCCN3Sn7AdEPmc5q5D',
          event_callback: go,
        });
      } catch (e) {
        go();
        return;
      }
      setTimeout(go, 1000);
    } else {
      go();
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!isWaParaibaHref(href)) return;
      var url = a.href;
      if (!url || url.indexOf('javascript:') === 0) return;
      e.preventDefault();
      fireConversion(function () {
        window.location.href = url;
      });
    },
    true
  );
})();
